<section class="table">
  <!-- <div class="loading" *ngIf="state">
    <app-spinner></app-spinner>
  </div> -->

  <div class="p-b-8 title-container">
    <!-- tittle -->
    <div fxLayout="row" class="title-row">
      <div class="table-title">
        <div class="title-wrapper">
          <span class="title">{{ title }}</span>
        </div>
        <div class="buttons-table">
          <ng-content [buttons-table]></ng-content>
        </div>
      </div>

      <div class="bulk-actions" *ngIf="displayedColumns?.includes('select')">
        <div class="checkbox-ddl" *ngIf="disableButtons">
          <!-- <ng-container *ngIf="showTableBulkActionsMenu">
              <nz-select
                [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                [nzPlaceHolder]="'Attendance.BulkActionsDDL.PlaceHolder' | translate"
                nzShowSearch
                [nzBackdrop]="true"
                [nzAllowClear]="true"
                (ngModelChange)="selectAll ? onBulkActionsSelected($event) : onChangeAction($event)"
                [ngModel]="undefined"
                [nzDisabled]="!disableButtons"
              >
                <ng-container *ngFor="let action of bulkActionMenu ">
                  <nz-option
                    nzCustomContent
                    *ngIf="action.show"
                    [nzValue]="action.value"
                    [nzLabel]="'TableComponent.BulkActionsMenu.' + action.key| translate"
                  >
                    <span id="option" class="{{action.className}}">{{'TableComponent.BulkActionsMenu.' + action.key| translate}}</span>
                  </nz-option>
                </ng-container>
              </nz-select>
            </ng-container> -->
        </div>
      </div>
    </div>
    <div class="filters-container-wrap" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="5px">
      <!-- Filter -->

      <!-- FilterButton -->

      <!-- <div class="" *ngIf="showFiltersDropdown">
          <button
            (click)="onFiltersButtonClicked()"
            class="filter-button"
            [ngClass]="(openFilterComponent) ? 'filter-btn-active' : ''"
            mat-stroked-button
          >
            <img [src]="'./../../../../../assets/images/Vector.svg'" />
            {{ "BUTTON.Filters" | translate}}
          </button>
        </div> -->
    </div>
  </div>
  <mat-card-actions>
    <!-- ***************** -->
    <!-- table inside filters -->
    <!-- <div class="inside-filters-component" *ngIf="openFilterComponent">
        <ng-content select="[inside-table-filters]"></ng-content>
      </div> -->
    <!-- ***************** -->

    <!-- filters -->
    <div class="filters" *ngIf="tableConfigurations?.showFilters">
      <app-table-header (colorToggleChange)="onColorToggleChange($event)">
        <ng-container filters>
          <ng-content select="[filters-table]"></ng-content>
        </ng-container>
      </app-table-header>
    </div>
    <!-- Table -->
    <div class="table-container-item" *ngIf="tableDataSource.filteredData?.length > 0" [style.maxHeight]="tableHeight$ | async">
      <table mat-table [dataSource]="tableDataSource" matSort (matSortChange)="sortTable($event)" class="table">
        <ng-container matColumnDef="select">
          <th class="selectable" mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="
                tableDataSource.data
                  | checkboxStatusChecker : selection.selected : checkBoxStatus
              "
              [indeterminate]="
                (tableDataSource.data
                  | checkboxStatusChecker
                    : selection.selected
                    : checkBoxStatus) &&
                checkBoxStatus == CheckboxStatus.INDETERMINATE
              "
            ></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row | functionBoolean : addToSelectionCallBackFunction">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? checkedSelectRow(row) : null"
                [checked]="row | functionBoolean : selection.isSelected(row)"
              ></mat-checkbox>
            </ng-container>
          </td>
        </ng-container>
        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">
          <!-- if sortable column header -->
          <ng-container *ngIf="tableColumn.isSortable; else notSortable">
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.name" [arrowPosition]="'after'">{{ tableColumn.name }}</th>
          </ng-container>
          <!-- else not sortable -->
          <ng-template #notSortable>
            <th mat-header-cell *matHeaderCellDef>{{ tableColumn.name }}</th>
          </ng-template>

          <!-- column data -->
          <td
            mat-cell
            *matCellDef="let element ; let i = index"
            class="table-header"
            (click)="onRowActionClicked($any(TableRowClicked.ROW_CLICKED), element)"
          >
            <!--  start expandable cell -->
            <ng-container *ngIf="tableColumn?.showExpandableCell">
              <app-expandable-content>
                <span *ngIf="!tableColumn.hideDefaultCell" [innerHtml]="element | getNestedObjectValuesByString : tableColumn.dataKey"></span>
                <ng-container *ngIf="tableColumn.showCustomTemplateCell">
                  <ng-template
                    [ngTemplateOutlet]="customCellTemplate"
                    [ngTemplateOutletContext]="{
                      $implicit: element,
                      dataKey: tableColumn.dataKey,
                      disableButtons: disableButtons,
                      index : i
                    }"
                  ></ng-template>
                </ng-container>
              </app-expandable-content>
            </ng-container>
            <!-- end expandable cell -->

            <!-- ============================ -->
            <!-- start not expandable cell -->
            <ng-container *ngIf="!tableColumn?.showExpandableCell">
              <span *ngIf="!tableColumn.hideDefaultCell" [innerHtml]="element | getNestedObjectValuesByString : tableColumn.dataKey"></span>
              <ng-container *ngIf="tableColumn.showCustomTemplateCell">
                <ng-template
                  [ngTemplateOutlet]="customCellTemplate"
                  [ngTemplateOutletContext]="{
                      $implicit: element,
                      dataKey: tableColumn.dataKey,
                      disableButtons: disableButtons,
                      index : i
                    }"
                ></ng-template>
              </ng-container>
            </ng-container>
            <!-- end not expandable cell -->
          </td>
        </ng-container>

        <!-- buttons cloumn -->
        <ng-container *ngIf="buttons?.length" [matColumnDef]="buttonColumn" stickyEnd>
          <th class="button-header-cell" mat-header-cell *matHeaderCellDef>{{buttonColumn}}</th>
          <td class="button-column-items" mat-cell *matCellDef="let element; let i = index">
            <ng-container *ngIf="!disableButtons && hasVisibleButtons(element)">
              <ng-container *ngIf="buttons.length">
                <ng-container
                  [ngTemplateOutlet]="tableConfigurations?.isButtonsFlat ? flatButtons : menuButtons"
                  [ngTemplateOutletContext]="{ buttons : buttons , element : element , i : i  }"
                ></ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row class="header-row" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let odd = odd"
          [ngClass]="{
              'cursor-pointer': tableConfigurations?.isSelectable,
              'isEven': !odd && colorToggle
            }"
        ></tr>
      </table>
    </div>
  </mat-card-actions>
</section>
<!--     -->

<!-- start flat buttons template -->
<ng-template #flatButtons let-buttons="buttons" let-element="element" let-i="i">
  <div class="buttons-container">
    <ng-container *ngFor="let button of buttons">
      <ng-container *ngIf="(button | callBackFunction : button?.transformButton : element)">
        <ng-container *ngIf="(button | callBackFunction : button?.transformButton : element).showButton !== false">
          <button
            *ngIf="element | functionBoolean : button.showButtonsCallbackFunction : element?.[button.buttonPropertyChange] : button"
            [disabled]="(button | callBackFunction : button?.transformButton : element).isDisabled"
            mat-menu-item
            (click)="
          onRowActionClicked(button.actionToPerform, element , i)
        "
            class="table-button {{ button.class }}"
            [title]="(button | callBackFunction : button?.transformButton : element).title"
            [style.background-color]="(button | callBackFunction : button?.transformButton : element).backgroundColor"
          >
            <mat-icon [style.color]="(button | callBackFunction : button?.transformButton : element).color">{{button.icon}}</mat-icon>
          </button>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
<!-- end flat buttons template -->

<!-- --------------------------------------------- -->

<!-- start menu buttons template -->
<ng-template #menuButtons let-buttons="buttons" let-element="element" let-i="i">
  <button class="menu-button" mat-button [matMenuTriggerFor]="buttonsMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <!-- start menu -->
  <mat-menu #buttonsMenu="matMenu">
    <div class="menu-buttons-container">
      <ng-container *ngFor="let button of buttons">
        <ng-container *ngIf="(button | callBackFunction : button?.transformButton : element)">
          <ng-container *ngIf="(button | callBackFunction : button?.transformButton : element).showButton !== false">
            <button
              *ngIf="element | functionBoolean : button.showButtonsCallbackFunction : element?.[button.buttonPropertyChange] : button"
              [disabled]="(button | callBackFunction : button?.transformButton : element).isDisabled"
              (click)="onRowActionClicked(button.actionToPerform, element , i)"
            >
              <mat-icon *ngIf="button.icon">{{button.icon}}</mat-icon>
              <app-svg-icon *ngIf="button.svgIcon" [icon]="button?.svgIcon"></app-svg-icon>
              {{(button | callBackFunction : button?.transformButton : element).title}}
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </mat-menu>
  <!-- end menu -->
</ng-template>
<!-- end menu buttons template -->
